// @core/api/endpoints/analytics/get_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReportResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Get report
 * Retrieves a report by ID including generation status and download URL.
 */
export async function GetReport(
  report_id: string,
  options?: RequestOptions
): Promise<ReportResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/reports/:report_id`;
  requestPath = requestPath.replace(':report_id', encodeURIComponent(report_id));
  const requestOptions = options;
  return client.get<ReportResponse>(requestPath, { ...requestOptions });
}
